import script from "./ContactsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsBlock.vue?vue&type=script&setup=true&lang=js"

import "./ContactsBlock.vue?vue&type=style&index=0&id=74e5caf6&lang=scss"

const __exports__ = script;

export default __exports__